export const formatWholePounds = (
  price: string,
  hasWholePoundsOnlyEnabled: boolean,
) => (hasWholePoundsOnlyEnabled ? price.replace(/\.00\b/g, "") : price);
